import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "@/App";
import { toast } from "sonner";
import { Beer } from "lucide-react";
import axios from "axios";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionId = hash.split('session_id=')[1]?.split('&')[0];

        if (!sessionId) {
          throw new Error('No session_id found');
        }

        // Exchange session_id for user data
        const response = await axios.post(`${API}/auth/session`, {
          session_id: sessionId
        });

        login(response.data);
        toast.success("Welcome, rider!");
        
        // Clear hash and navigate
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { replace: true, state: { user: response.data } });

      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Authentication failed');
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="mobile-container min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Beer className="w-12 h-12 text-bronze mx-auto animate-pulse" />
        <p className="text-gray-400 mt-4 uppercase tracking-wide text-sm">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
